module.exports = __webpack_public_path__ + "img/pie_diamond.ab2c277c.png";